import React from 'react';
import '../style/ImgCard.scss';
function ImgCard({title,description,img,cardTitle1, cardSubTitle1,cardTitle2, cardSubTitle2,cardTitle3, cardSubTitle3,cardTitle4, cardSubTitle4}) {
  return (
      <div id={'ImgCard'}>
        <div className="section-wrapper">
          <div className="title-wrapper">{title}</div>
          <div className="description-wrapper">{description}</div>
          <div className="content-wrapper">
            <img className="content-img-wrapper" src={img} alt={''}/>
            <div className="content-card-wrapper">
              <div className="content-card">
                <div className="content-card-title">{cardTitle1}</div>
                <div className="content-card-subTitle">{cardSubTitle1}</div>
              </div>
              <div className="content-card">
                <div className="content-card-title">{cardTitle2}</div>
                <div className="content-card-subTitle">{cardSubTitle2}</div>
              </div>
              <div className="content-card">
                <div className="content-card-title">{cardTitle3}</div>
                <div className="content-card-subTitle">{cardSubTitle3}</div>
              </div>
              <div className="content-card last">
                <div className="content-card-title">{cardTitle4}</div>
                <div className="content-card-subTitle">{cardSubTitle4}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default ImgCard;